import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {CommonsFacadeService} from "../../../commons/angular/state/commons/commons-facade.service";
import {SortType} from "../../../commons/types/sort.type";
import {TeamModel} from "../../models/team.model";
import {TeamsDialogService} from "../../services/teams-dialog.service";
import {TeamsService} from "../../services/teams.service";
import {TeamsHttpService} from "../../angular/services/teams-http.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {AgentsService} from "../../../agents/services/agents-service.service";

export class TeamsViewComponent implements IController {

  teams: TeamModel[];
  memberId: string;

  public loadLimit = 20;
  public queryString: string;
  public cursor: string;
  public sortTypesValues: any;
  public selectedSortValue: any;
  public isFetchingData: boolean;
  public filteredTeams: TeamModel[];

  constructor(private teamsDialogService: TeamsDialogService, private teamsService: TeamsService, private teamsHttpService: TeamsHttpService,
              private commonsFacadeService: CommonsFacadeService, private $timeout, private $state, private confirmDialogService: ConfirmDialogService,
              private agentsService: AgentsService) {
  }

  $onInit() {
    this.sortTypesValues = {
      sortCreatedAt: {asc: 'createdAt,asc', desc: 'createdAt,desc'},
      sortName: {asc: 'name,asc', desc: 'name,desc'},
    };
    this.selectedSortValue = undefined;

    if (!this.memberId) {
      this.filteredTeams = [];
      this.getTeams();
    } else {
      this.filteredTeams = angular.copy(this.teams);
    }
  };

  onCreateTeam() {
    this.teamsDialogService.createTeam()
      .then((payload) => {
        this.createTeam(payload.team, payload.teamAgentIds);
      })
  }

  onEditTeam(team: TeamModel) {
    this.teamsService.getTeamsAgentIds([team.id])
      .then((agentIds) => {
        const teamCopy = angular.copy(team);
        this.teamsDialogService.editTeam(teamCopy, agentIds)
          .then((payload) => {

            const agentIdsToAdd: string[] = _.difference(payload.teamAgentIds, agentIds);
            const agentIdsToRemove: string[] = _.difference(agentIds, payload.teamAgentIds);

            this.editTeam(payload.team, agentIdsToAdd, agentIdsToRemove);
          })
      })
  }

  onDeleteTeam(team: TeamModel) {
    this.confirmDialogService.confirm('Delete Team', 'Are you sure you want to delete this team?', undefined)
      .then(() => {
        if (!this.memberId) {
          this.deleteTeam(team.id);
        } else {
          const teamCopy = angular.copy(team);
          teamCopy.memberIds = [];
          this.removeAdminFromTeam(teamCopy);
        }
      })
  }

  onAddAdminToTeam() {
    this.teamsDialogService.addAdminToTeam()
      .then((team) => {
        const teamCopy = angular.copy(team);

        if (!teamCopy.memberIds) {
          teamCopy.memberIds = []
        }
        teamCopy.memberIds.push(this.memberId);
        this.changeTeamAdmin(teamCopy);
      })
  }

  onQueryChange(query) {
    this.filteredTeams = [];
    this.queryString = query;
    this.cursor = undefined;

    if (!!this.memberId) {
      if (!this.queryString) {
        this.filteredTeams = angular.copy(this.teams);
      } else {
        this.filteredTeams = this.teams.filter(team => {
          return _.includes(JSON.stringify(team).toLowerCase(), query.toLowerCase());
        })
      }
    } else {
      this.getTeams();
    }
  }

  onSortTypeChange(sortName) {
    this.filteredTeams = [];
    const isSameSortName = !!this.selectedSortValue && _.isEqual(this.selectedSortValue.name, sortName);
    const newType = isSameSortName ? _.isEqual(this.selectedSortValue.type, SortType.asc) ? SortType.desc : SortType.asc : SortType.asc;

    this.selectedSortValue = {
      name: sortName,
      type: isSameSortName ? newType : SortType.asc,
      value: isSameSortName ? this.sortTypesValues[sortName][newType] : this.sortTypesValues[sortName].asc
    }

    this.getTeams();
  }


  _getTeamsQuery() {

    const params = {
      limit: this.loadLimit,
      query: this.queryString,
      cursor: this.cursor,
      // name: this.queryString
      // sort: _.get(this.selectedSortValue, 'value')
    }

    Object.keys(params).forEach(key => (params[key] === undefined || params[key] === '') && delete params[key]);
    return params;
  }

  getTeams(cursor?: string) {
    const params: any = this._getTeamsQuery();
    if (!!cursor) {
      params.cursor = cursor;
    }

    this.isFetchingData = true;
    this.commonsFacadeService.setLoaderOn();
    this.teamsHttpService.getTeams(params).subscribe({
      next: (res) => {
        this.cursor = res.cursor;
        this.filteredTeams = _.uniqBy([...this.filteredTeams, ...res.list], 'id');
        this.$timeout(() => {
        }, 0);
      },
      error: (err) => {
        this.commonsFacadeService.setLoaderOff();
        this.isFetchingData = false;
      },
      complete: () => {
        this.commonsFacadeService.setLoaderOff();
        this.isFetchingData = false;
      }
    });
  }

  fetchNext() {
    if (!this.cursor || this.isFetchingData) {
      return;
    }
    this.getTeams(this.cursor);
  }

  private createTeam(team: TeamModel, agentIds: string[]) {
    this.teamsService.createTeam(team)
      .then((team: TeamModel) => {
        const teamsCopy = angular.copy(this.filteredTeams);
        teamsCopy.push(team);
        this.filteredTeams = teamsCopy;
        this.agentsService.addAgentsToTeam([team.id], agentIds);
      });
  }

  private changeTeamAdmin(team: TeamModel) {
    this.teamsService.updateTeamAdmins(team)
      .then((updatedTeam: TeamModel) => {
        const teamsCopy = angular.copy(this.filteredTeams);
        teamsCopy.push(updatedTeam);
        this.filteredTeams = teamsCopy;
      });
  }

  private removeAdminFromTeam(team: TeamModel) {
    this.teamsService.updateTeamAdmins(team)
      .then((updatedTeam: TeamModel) => {
        const teamsCopy = angular.copy(this.filteredTeams);
        const teamIndex = this.filteredTeams.findIndex(t => t.id === updatedTeam.id);
        teamsCopy.splice(teamIndex, 1);
        this.filteredTeams = teamsCopy;
      });
  }

  private editTeam(team: TeamModel, agentIdsToAdd: string[], agentIdsToRemove: string[]) {
    this.teamsService.editTeam(team)
      .then((updatedTeam: TeamModel) => {
        const teamIndex = this.filteredTeams.findIndex(t => t.id === team.id);
        const teamsCopy = angular.copy(this.filteredTeams);
        teamsCopy[teamIndex] = updatedTeam;
        this.filteredTeams = teamsCopy;

        if (!!agentIdsToAdd?.length) {
          this.agentsService.addAgentsToTeam([team.id], agentIdsToAdd);
        }

        if (!!agentIdsToRemove?.length) {
          this.agentsService.removeAgentsFromTeam([team.id], agentIdsToRemove);
        }
      });
  }

  private deleteTeam(teamId: string) {
    this.teamsService.deleteTeam(teamId)
      .then(() => {
        const teamIndex = this.filteredTeams.findIndex(t => t.id === teamId);
        const teamsCopy = angular.copy(this.filteredTeams);
        teamsCopy.splice(teamIndex, 1);
        this.filteredTeams = teamsCopy;
      });
  }

}

angular
  .module('bringoz.admin.teams')
  .component('teamsView', {
    bindings: {
      teams: '<?',
      memberId: '<?',
    },
    template: require('./teams-view.html').default,
    controller: TeamsViewComponent
  });
